module.exports = __webpack_public_path__ + "img/sbl0006.b8d88603.png";